import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { UtilsService } from '../../services/helpers/utils.service';
import { ModalErrorComponent } from '../../sections/modal-error/modal-error.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { User, Dictionary } from '../../models/models';
import { ModalSearchUserComponent } from "../../sections/modal-search-user/modal-search-user.component";
import { AuthGuard } from "../../services/auth/auth.guard";

@Component({
  selector: 'app-offer-members',
  templateUrl: './offer-members.component.html',
})
export class OfferMembersComponent implements OnInit {

  constructor(
    private _authGuard: AuthGuard,
    private _modalService: NgbModal
  ) {
  }

  private currentUser : User;

  @Input() headerText: string;
  @Input() searchMemberHeaderText: string;
  @Input() memberExistsErrorText: string;
  @Input() addButtonText: string;
  @Input() memberList: User[];

  @Input() isAuthors: boolean;
  @Input() isCoAuthors: boolean;
  @Input() isRealizers: boolean;

  @Input() showPercentage: boolean;
  @Input() allowEditPercentage: boolean;
  @Input() allowEditMemberList: boolean;

  @Output() memberListChange = new EventEmitter<User[]>();


  ngOnInit() {
    this._authGuard.authLoggedIn$.subscribe((user) => (this.currentUser = user));
  }

  private _openModalWindow(content: any) {
    const modalRef = this._modalService.open(content, { windowClass: 'custom-position-modal' });
    return modalRef;
  }

  public addButtonClick(): void {
    const modalRef = this._openModalWindow(ModalSearchUserComponent);
    modalRef.componentInstance.title = this.searchMemberHeaderText;
    modalRef.componentInstance.multiple = true;
    modalRef.componentInstance.currentUserId = this.currentUser.id;
    modalRef.componentInstance.passEntry.subscribe((result: User[]) => {
      let userExists = false;
      for (let i = 0; i < result.length; i++) {
        if (this.memberList.filter((item) => item.id == result[i].id).length > 0) {
          userExists = true;
        }
      }

      if (!userExists) {
        result.forEach((element) => {
          const res = {
            ...element,
            isAuthor: this.isAuthors,
            isCoAuthor: this.isCoAuthors,
            isRealizer: this.isRealizers,
            checked: false,
            partInProject: 0
          };

          this.memberList = this.memberList.concat(res);
          this.memberListChange.emit(this.memberList);
        });
      }
      else {
        const errorModalRef = this._openModalWindow(ModalErrorComponent);
        errorModalRef.componentInstance.errors = [this.memberExistsErrorText];
      }
    });
  }

  public deleteButtonClick(item: User): void {
    var index = this.memberList.indexOf(item);
    if (index !== -1) {
      this.memberList.splice(index, 1);
      this.memberListChange.emit(this.memberList);
    }
  }
}
